import { AnimateReveal } from "~components/AnimateReveal/AnimateReveal";
import {
  ListItem,
  ListItemProps,
} from "~features/checkout/common/components/OrderSummary/components/ListItem";
import { useOrderSummaryContext } from "~features/checkout/common/components/OrderSummary/context/OrderSummaryContext";
import { useOrderContext } from "~features/checkout/common/hooks/OrderContext";
import { useOrganization } from "~hooks/useOrganization";
import { getPromoCodeLabel } from "~services/order/hooks/useCalculatePromoCodeDiscount";

/**
 * PromoCodeSummary component for displaying applied promo code discount
 * Used in StandardCheckout order summary
 */
export function PromoCodeSummary(props: Partial<ListItemProps>) {
  const { order } = useOrderContext();
  const { organization } = useOrganization();
  const { isLoading } = useOrderSummaryContext();

  const promoCode = order?.promoCode;

  if (!promoCode) {
    return null;
  }

  // Calculate discount amount based on promo code type
  const getDiscountAmount = () => {
    if (promoCode.discountType === "PERCENTAGE") {
      // For percentage discounts, calculate from order total
      const orderTotal = order?.total || 0;
      return orderTotal * (promoCode.discountAmount / 100) * -1;
    } else {
      // For fixed amount discounts
      return promoCode.discountAmount * -1;
    }
  };

  const discountAmount = getDiscountAmount();
  const label = getPromoCodeLabel(promoCode, organization?.currency);

  return (
    <AnimateReveal initial={true} show={true}>
      <ListItem
        title="Promo code"
        subtitle={label}
        price={discountAmount}
        isLoading={isLoading}
        {...props}
      />
    </AnimateReveal>
  );
}
